var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 18.9596C5.05768 18.9596 1.04102 14.943 1.04102 10.0013C1.04102 5.05963 5.05768 1.04297 9.99935 1.04297C14.941 1.04297 18.9577 5.05963 18.9577 10.0013C18.9577 14.943 14.941 18.9596 9.99935 18.9596ZM9.99935 2.29297C5.74935 2.29297 2.29102 5.7513 2.29102 10.0013C2.29102 14.2513 5.74935 17.7096 9.99935 17.7096C14.2493 17.7096 17.7077 14.2513 17.7077 10.0013C17.7077 5.7513 14.2493 2.29297 9.99935 2.29297Z",
    fill: "#FF6551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.64245 12.9851C7.48411 12.9851 7.32578 12.9268 7.20078 12.8018C6.95911 12.5601 6.95911 12.1601 7.20078 11.9184L11.9174 7.20176C12.1591 6.96009 12.5591 6.96009 12.8008 7.20176C13.0424 7.44342 13.0424 7.84342 12.8008 8.08509L8.08411 12.8018C7.96745 12.9268 7.80078 12.9851 7.64245 12.9851Z",
    fill: "#FF6551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3591 12.9851C12.2008 12.9851 12.0424 12.9268 11.9174 12.8018L7.20078 8.08509C6.95911 7.84342 6.95911 7.44342 7.20078 7.20176C7.44245 6.96009 7.84245 6.96009 8.08411 7.20176L12.8008 11.9184C13.0424 12.1601 13.0424 12.5601 12.8008 12.8018C12.6758 12.9268 12.5174 12.9851 12.3591 12.9851Z",
    fill: "#FF6551"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.f8d0e461655eba388a5c4d5c3b519aa6.svg";
export { ForwardRef as ReactComponent };